import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ProductImageComponent } from "@components/product-image/product-image.component";
import { LocalizeProductNamePipe, Product } from "@domain/product/product";

@Component({
  selector: "app-fgds-product-search-item",
  templateUrl: "./fgds-product-search-item.component.html",
  styleUrl: "./fgds-product-search-item.component.scss",
  imports: [UiKitModule, ProductImageComponent, LocalizeProductNamePipe],
  standalone: true,
})
export class FgdsProductSearchItemComponent {
  @Input({ required: true }) product!: Product;
  @Input() showMenu = true;
  @Input() canAddToFloorplan = true;
  @Input() isShownOnProductList = false;
  @Output() addToFloorplan = new EventEmitter<void>();
  @Output() addToBom = new EventEmitter<void>();

  protected onCardClick(): void {
    if (!this.canAddToFloorplan || this.isShownOnProductList) {
      this.onAddToBomClick();
      return;
    }
    this.addToFloorplan.emit();
  }

  protected onAddToBomClick(): void {
    this.addToBom.emit();
  }
}
